import Image from 'next/image';
import styles from './WhatSetsApart.module.css';
export function WhatSetsApart() {
    return (
        <section className="section bgLigtgray">
            <div className="containerFull">
                <h2 className="font26 f500 text000 textCenter fontSM20 mb20">What Sets <span className="textpink">Apart?</span></h2>
                <p className="font16 textCenter text666">Elevate beyond the ordinary. Choose excellence with Interior Company.</p>
                <div className="containFull">
                    <div className={styles.setApartmaibox}>
                        <div className={styles.setAparttiles}>
                            <figure>
                                <Image width={36} height={36} src="/assets/images/wesetTick.svg" alt="" />
                            </figure>
                            <div className={styles.setSidetext}>
                                <h3 className="f600 font18 text222">One-Stop Solution For Interior Design</h3>
                                <p className="font16 text666 mt16">Meet all your home interior design needs under one roof.</p>
                            </div>
                        </div>
                        <div className={styles.setAparttiles}>
                            <figure>
                                <Image width={36} height={36} src="/assets/images/wesetTick.svg" alt="" />
                            </figure>
                            <div className={styles.setSidetext}>
                                <h3 className="f600 font18 text222">Best Designing Experts</h3>
                                <p className="font16 text666 mt16">We craft bespoke design solutions that reflect your personality.</p>
                            </div>
                        </div>
                        <div className={styles.setAparttiles}>
                            <figure>
                                <Image width={36} height={36} src="/assets/images/wesetTick.svg" alt="" />
                            </figure>
                            <div className={styles.setSidetext}>
                                <h3 className="f600 font18 text222">Immersive 3D Walkthroughs</h3>
                                <p className="font16 text666 mt16">Experience home interiors with interactive 3D visual walkthroughs.</p>
                            </div>
                        </div>
                        <div className={styles.setAparttiles}>
                            <figure>
                                <Image width={36} height={36} src="/assets/images/wesetTick.svg" alt="" />
                            </figure>
                            <div className={styles.setSidetext}>
                                <h3 className="f600 font18 text222">Honest Pricing</h3>
                                <p className="font16 text666 mt16">Transparent pricing with no hidden charges for interior fit-out services.</p>
                            </div>
                        </div>
                        <div className={styles.setAparttiles}>
                            <figure>
                                <Image width={36} height={36} src="/assets/images/wesetTick.svg" alt="" />
                            </figure>
                            <div className={styles.setSidetext}>
                                <h3 className="f600 font18 text222">Customer Support</h3>
                                <p className="font16 text666 mt16">We ensure that all your queries are resolved at the earliest.</p>
                            </div>
                        </div>
                        <div className={styles.setAparttiles}>
                            <figure>
                                <Image width={36} height={36} src="/assets/images/wesetTick.svg" alt="" />
                            </figure>
                            <div className={styles.setSidetext}>
                                <h3 className="f600 font18 text222">Consistent Quality Checks</h3>
                                <p className="font16 text666 mt16">Strict quality inspections are carried out at various stages of the project.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}